import { ClaimStatus, ClaimStatusValue } from "../../../constants/claim-status.enum";

export interface IClaimCard {
  title: string;
  status: string;
  type: ClaimStatus;
  data?: CardDetails[]
  count?: number;
  activeClaims?: number;
  inActiveClaims?: number;
  percentage?: number;
  message?: string;
  statusId?: string;
  isNotSavedCard?: boolean;
}

interface CardDetails {
  title: string;
  value: string | number;
}

export const TitleByAPI: { [key in string]: string } = {
  totalNet: 'PREAUTH.PREAUTH_REQUEST.ITEMS.NET',
  totalTax: 'CLAIM.CLAIM_SUMMARY.VIEW_CLAIMS.TAX',
  totalPatientShare: 'FORM_FIELD.PATIENT_SHARE',
  totalPayerShare: 'PREAUTH.PREAUTH_PROCESS.PAYER_SHARE'
};

export const TitleByAPIHistory: { [key in string]: string } = {
  totalNet: 'PREAUTH.PREAUTH_REQUEST.ITEMS.NET',
};

export interface claimDetails {
  title: string,
  color: string,
  backgroundColor: string,
  id: string,
}

export const ClaimDetailsMap = {
  [ClaimStatus.Draft]: {
    title: 'PREAUTH.STATUS_TYPE.DRAFT',
    color: '#6f42c1',
    backgroundColor: '#ede4f9',
    id: ClaimStatusValue[ClaimStatus.Draft]
  },
  [ClaimStatus.UnderReview]: {
    title: 'PREAUTH.STATUS_TYPE.UNDER_REVIEW',
    color: '#25b6c0',
    backgroundColor: '#c9f2f4',
    id: ClaimStatusValue[ClaimStatus.UnderReview]
  },
  [ClaimStatus.AllClaims]: {
    title: 'PREAUTH.STATUS_TYPE.ALL_CLAIMS',
    color: '#3060aa',
    backgroundColor: '#d8e5f2',
    id: ClaimStatusValue[ClaimStatus.AllClaims],
  },
  [ClaimStatus.Cancelled]: {
    title: 'PREAUTH.STATUS_TYPE.CANCELLED',
    color: '#d03131',
    backgroundColor: '#f2c4c4',
    id: ClaimStatusValue[ClaimStatus.Cancelled]
  },
  [ClaimStatus.PartiallyApproved]: {
    title: 'PREAUTH.STATUS_TYPE.PARTIALLY_APPROVED',
    color: '#458fb3',
    backgroundColor: '#dcebf3',
    id: ClaimStatusValue[ClaimStatus.PartiallyApproved]
  },
  [ClaimStatus.ValidationErrors]: {
    title: 'PREAUTH.STATUS_TYPE.VALIDATION_ERRORS',
    color: '#d81b49',
    backgroundColor: '#f9cfd8',
    id: ClaimStatusValue[ClaimStatus.ValidationErrors]
  },
  [ClaimStatus.Queued]: {
    title: 'PREAUTH.STATUS_TYPE.QUEUED',
    color: '#d0a029',
    backgroundColor: '#f8ebcc',
    id: ClaimStatusValue[ClaimStatus.Queued]
  },
  [ClaimStatus.Approved]: {
    title: 'PREAUTH.STATUS_TYPE.APPROVED',
    color: '#36793d',
    backgroundColor: '#d7e9d8',
    id: ClaimStatusValue[ClaimStatus.Approved]
  },
  [ClaimStatus.Pended]: {
    title: 'PREAUTH.STATUS_TYPE.PENDED',
    color: '#7d0202',
    backgroundColor: '#e9b3b3',
    id: ClaimStatusValue[ClaimStatus.Pended]
  },
  [ClaimStatus.Rejected]: {
    title: 'PREAUTH.STATUS_TYPE.REJECTED',
    color: '#aa4549',
    backgroundColor: '#f6d6d7',
    id: ClaimStatusValue[ClaimStatus.Rejected]
  },
  [ClaimStatus.NotUploaded]: {
    title: 'PREAUTH.STATUS_TYPE.NOT_UPLOADED',
    color: '#d0a029',
    backgroundColor: '#f8ebcc',
    id: ClaimStatusValue[ClaimStatus.NotUploaded]
  },
  [ClaimStatus.NotRequired]: {
    title: 'PREAUTH.STATUS_TYPE.NOT_REQUIRED',
    color: '#3d3d3d',
    backgroundColor: '#e9e9e9',
    id: ClaimStatusValue[ClaimStatus.NotRequired]
  }
};

export const ClaimDetailsValueMap = Object.entries(ClaimDetailsMap).reduce((acc, [key, value]) => {
  const enumKey = key as keyof typeof ClaimStatus;
  const id = ClaimStatusValue[enumKey];
  acc[id] = {
    title: value.title,
    color: value.color,
    backgroundColor: value.backgroundColor,
  };
  return acc;
}, {} as Record<number, { title: string; color: string; backgroundColor: string }>);
